import { isYesterday, isToday, isTomorrow, isThisYear } from 'date-fns';
import { isDate } from 'lodash';
import { t } from 'utils/i18n';
import { shortTimeFormat, shortDateFullMonthFormat, fullDateFormat } from 'constants/dateFormats';
import { formatDate } from './formatDate';

const getDate = (date) => {
  if (isYesterday(date)) {
    return t('yesterday');
  }

  if (isToday(date)) {
    return t('today');
  }

  if (isTomorrow(date)) {
    return t('tomorrow');
  }

  if (isThisYear(date)) {
    return formatDate(date, shortDateFullMonthFormat);
  }

  return formatDate(date, fullDateFormat);
};

const getRelativeDateTime = (date) => {
  const rawDate = isDate(date) ? date : new Date(date);
  const formattedDate = getDate(rawDate);
  const formattedTime = formatDate(rawDate, shortTimeFormat);
  const dateTime = `${formattedDate} ${formattedTime}`;

  return { date: formattedDate, time: formattedTime, dateTime };
};

export default getRelativeDateTime;
